import useAfterMount from '@rio-cloud/rio-uikit/useAfterMount';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { updateAssetId } from './routeHelper';

export const useRouteState = (callback: () => void) => {
    const { pathname, search } = useLocation();
    const locationKey = `${pathname}${search}`;
    const [hydratedLocation, setHydratedLocation] = useState<string>();

    useEffect(() => {
        if (hydratedLocation === locationKey) {
            return;
        }

        callback();
        setHydratedLocation(locationKey);
    }, [callback, hydratedLocation, locationKey]);

    // Do not write store state back to the URL until the current location has
    // been applied. This prevents browser Back/Forward from being overwritten
    // by the selection from the previous location.
    return hydratedLocation === locationKey;
};

export const useUpdateRoute = ({
    newSubResource,
    newSearch,
    enabled = true,
}: {
    newSubResource: string | undefined;
    newSearch: string;
    enabled?: boolean;
}) => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const newPathname = updateAssetId(pathname, newSubResource);

    useAfterMount(() => {
        if (!enabled) {
            return;
        }

        if (pathname !== newPathname || search !== newSearch) {
            navigate(newPathname + newSearch);
        }
    }, [enabled, newPathname, newSearch, navigate, pathname, search]);
};
